import type MP4Box from 'mp4box';

const hasAudio = (info: MP4Box.Mp4BoxInfo): boolean => {
  if (!info.audioTracks.length) {
    console.log('No audio tracks found for video upload');
    return false;
  }
  return true;
};

export default hasAudio;
